export const LoadingSpinner = ({ size = 'md' }) => {
    const sizeClasses = {
        sm: 'w-4 h-4 border',
        md: 'w-6 h-6 border-2',
        lg: 'w-10 h-10 border-2',
    };

    return (
        <div className="flex items-center justify-center" data-testid="loading-spinner">
            <div className={`${sizeClasses[size]} spinner`}></div>
        </div>
    );
};

export const PageLoader = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="flex flex-col items-center gap-4">
                <LoadingSpinner size="lg" />
                <p className="text-sm text-muted-foreground">Loading...</p>
            </div>
        </div>
    );
};
